// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2ekIK","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__15AjG"};